import {API} from '../../Services';

async function CheckinData(code){
    let token =  localStorage.getItem('token');

    let mallIdArr = code.split("mc_");
    //let mallIdArr = "aVyPuDWZ8n";
    return API.post(`/users/check-ins`,{uid:mallIdArr[1]},{headers: { 'Authorization':  `Bearer ${token}`}});
}

export {CheckinData};
